const Utils = require('./Utils');

const Masking = {
    setTranslate: function setTranslate() {
        const swiper = this;
        const slides = swiper.slides;
        const length = slides.length;
        for (let i = 0; i < length; i += 1) {
            const $slideEl = swiper.slides.eq(i);
            const $targetEls = Masking.lazyGetTargets($slideEl, swiper.params.maskingEffect.targetEl);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
            let ty = 0;
            let tx2 = 100;
            let ty2 = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                ty2 = tx2;
                tx2 = 0;
            }

            $slideEl
                .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');

            let a = Math.min(1, Math.max(-1, $slideEl[0].progress));
            if (!swiper.params.loop) {
                if (i === 0) a = Math.max(0, a);
                if (i === length - 1) a = Math.min(0, a);
            }
            if (a > -1 && a < 1 && a !== 0) {
                a = Math.sqrt(Math.abs(a)) * a / Math.abs(a);
                swiper.transition = true;
            }

            if ($targetEls)
                $targetEls
                    .transform('translate3d(' + -tx2 * a + '%, ' + -ty2 * a + '%, 0px)');
        }
    },
    setTransition: function setTransition(duration) {
        const swiper = this;
        const $wrapperEl = swiper.$wrapperEl;
        const slides = swiper.slides;
        const $targetEls = Masking.lazyGetTargets($wrapperEl, swiper.params.maskingEffect.targetEl, '$targetEls');
        const $targetActiveEls = Masking.lazyGetTargets(slides.eq(swiper.activeIndex), swiper.params.maskingEffect.targetEl, '$targetEls');
        // slides.transition(duration);
        $targetEls.transition(duration);
        $targetEls.css({transitionProperty: 'transform'});


        if (duration !== 0) {
            $targetEls.css({
                transitionDelay: swiper.transition ? '0s' : duration * 0.75 + 'ms',
                transitionTimingFunction: 'cubic-bezier(0.266,0.412,0.612,1)'
                // transitionTimingFunction: 'cubic-bezier(0.16, 0.13, 0.38, 1)'
            });
            $targetActiveEls.css({
                transitionDelay: '0s',
                transitionTimingFunction: 'cubic-bezier(0.434, 0.004, 0.79, 0.698)'
                // transitionTimingFunction: 'cubic-bezier(0.63, 0, 0.8, 0.82)'
            });

            Masking.setTranslate.call(swiper);
        } else {
            $targetEls.css({transitionDelay: '0s'});
        }

        if (swiper.params.virtualTranslate && duration !== 0) {
            let eventTriggered = false;
            $targetEls.transitionEnd(function () {

                if (eventTriggered) { return; }
                if (!swiper || swiper.destroyed) { return; }
                eventTriggered = true;
                swiper.animating = false;
                swiper.transition = false;
                const triggerEvents = ['webkitTransitionEnd', 'transitionend'];
                for (let i = 0; i < triggerEvents.length; i += 1) {
                    $wrapperEl.trigger(triggerEvents[i]);
                }
            });
            $targetActiveEls.transitionEnd(function () { });
        }
    },
    lazyGetTargets: function lazyGetTargets($rootEl, el, name) {
        let $targetEls = $rootEl.data(name);
        if ($targetEls) return $targetEls;

        $targetEls = $rootEl.find(el);
        $rootEl.data(name, $targetEls);
        return $targetEls;
    }
};

const EffectMasking = {
    name: 'effect-masking',
    params: {
        maskingEffect: {
            targetEl: '.swiper-masking-target'
        }
    },
    create: function create() {
        const swiper = this;
        Utils.extend(swiper, {
            maskingEffect: {
                setTranslate: Masking.setTranslate.bind(swiper),
                setTransition: Masking.setTransition.bind(swiper)
            }
        });
    },
    on: {
        beforeInit: function beforeInit() {
            const swiper = this;
            if (swiper.params.effect !== 'masking')
                return;

            swiper.classNames.push(swiper.params.containerModifierClass + 'masking');
            const overwriteParams = {
                slidesPerView: 1,
                slidesPerColumn: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: true
            };
            Utils.extend(swiper.params, overwriteParams);
            Utils.extend(swiper.originalParams, overwriteParams);
        },
        init: function init() {
            const swiper = this;
            if (swiper.params.effect !== 'CanvasMaskAnimationControl')  return;
            swiper.CanvasMaskAnimationControlEffect.setTransition(0);
            swiper.CanvasMaskAnimationControlEffect.setTranslate();
        },
        setTranslate: function setTranslate() {
            const swiper = this;
            if (swiper.params.effect !== 'masking')  return;
            swiper.maskingEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
            const swiper = this;
            if (swiper.params.effect !== 'masking')  return;
            swiper.maskingEffect.setTransition(duration > 0 ? swiper.params.speed : 0);
        }/* ,
        slideChange: function slideChange() {
            const swiper = this;
            if (swiper.params.effect !== 'masking')  return;
            const slides = swiper.slides;

            let i;
            let $els;
            for (i = 0; i < slides.length; i++) {
                $els = Masking.lazyGetTargets(slides.eq(i), swiper.params.maskingEffect.targetEl, '$targetEls');
                $els.css({visibility: i === swiper.activeIndex || i === swiper.previousIndex ? 'visible' : 'hidden'});
            }
        }*/
    }
};

module.exports = EffectMasking;



// WEBPACK FOOTER //
// ./js/swiperEffects/MaskingEffect.js